export const ActionTypes = {
  ACCEPT_TERMS_AND_CONDITIONS: 'ACCEPT_TERMS_AND_CONDITIONS'
}